module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "race-question"
  }, [_c('modal', {
    staticClass: "luckyRunner",
    attrs: {
      "name": "luckyRunner"
    },
    on: {
      "before-close": _vm.onClose
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Today's Lucky LiveRunner is...")]), _vm._v(" "), _c('div', {
    staticClass: "runnerName"
  }, [_vm._v(_vm._s(_vm.details.runner.firstName) + " " + _vm._s(_vm.details.runner.lastName))]), _vm._v(" "), _c('div', {
    staticClass: "gift"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gift),
      expression: "gift"
    }],
    attrs: {
      "label": "Gift",
      "name": "Gift"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.gift = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeHandle]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.defaultOption))]), _vm._v(" "), _vm._l((_vm.lang == 'Km' ? _vm.giftOption : _vm.giftOptionEng), function(gift, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": gift
      }
    }, [_vm._v(_vm._s(gift))])
  })], 2)]), _vm._v(" "), (_vm.noGiftSelected) ? _c('div', {
    staticClass: "errorMsg"
  }, [_vm._v("No Gift Selected !!")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "saveBtn"
  }, [_c('button', {
    staticClass: "btn btn--primary",
    staticStyle: {
      "float": "none"
    },
    on: {
      "click": function($event) {
        return _vm.Save()
      }
    }
  }, [_vm._v("Send")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-136c206a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/LuckyLiveRunner.vue
// module id = 1662
// module chunks = 2